var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 text-center p-2"},[_c('div',{staticClass:"lds-ring"},[_c('div',{style:({ width: _vm.w + 'px', height: _vm.w + 'px' })}),_c('div',{style:({ width: _vm.w + 'px', height: _vm.w + 'px' })}),_c('div',{style:({ width: _vm.w + 'px', height: _vm.w + 'px' })}),_c('div',{style:({ width: _vm.w + 'px', height: _vm.w + 'px' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }